angular.module('menuUtils').service('tgMenu', [
	'$http',
	'$location',
	'tgConfig',
	function ($http, $location, tgConfig) {
		$http.defaults.headers.common.apptoken = tgConfig.apptoken
		var urlBase = tgConfig.api.replace('http', $location.protocol()) + '/'

		this.getMenuWithItems = function (menuId, language) {
			if (!menuId) {
				return null
			}
			if (!language) language = 'pt'

			var httpConfig = {
				method: 'GET',
				url: urlBase + 'Menu/' + menuId + '/withItems',
				cache: true,
				params: { language: language }
			}
			return $http(httpConfig)
		}

		this.getImagePath = function (image, itemType, original) {
			if (!image || image.length == 0 || image.toLowerCase().match(/no_image/)) {
				if (itemType == 'dish') {
					return tgConfig.imageUrl + 'MenuItem/dish_no_image.png'
				} else if (itemType == 'wine') {
					return tgConfig.imageUrl + 'MenuItem/wine_no_image.png'
				} else if (itemType == 'pantry') {
					return tgConfig.imageUrl + 'MenuItem/pantry_no_image.png'
				}
			} else {
				return !original ? tgConfig.imageUrl + 'thumbs/' + image : tgConfig.imageUrl + image
			}
		}

		this.getVarietalsList = function (item, language) {
			if (!language) language = 'pt'

			var percVarietals = _.filter(item.product.wineDetails.varietals, function (v) {
				return !!v.value
			})
			if (_.isEmpty(percVarietals)) {
				percVarietals = []
			} else {
				percVarietals.sort(function (a, b) {
					return parseFloat(b.value) - parseFloat(a.value)
				})
			}

			var unavailablePercVarietals = _.filter(item.product.wineDetails.varietals, function (v) {
				return !v.value
			})
			if (_.isEmpty(unavailablePercVarietals)) {
				unavailablePercVarietals = []
			} else {
				unavailablePercVarietals = _.sortBy(unavailablePercVarietals, ['feature.name.' + language])
			}

			var varietals = percVarietals.concat(unavailablePercVarietals)

			var i18nAndAdverb
			switch (language) {
				case 'en':
					i18nAndAdverb = 'and'
					break
				case 'es':
					i18nAndAdverb = 'y'
					break
				case 'fr':
					i18nAndAdverb = 'et'
					break
				default:
					i18nAndAdverb = 'e'
					break
			}

			var varietalsList = ''
			for (var i = 0; i < varietals.length; i++) {
				var varietal = varietals[i]

				if (!_.isEmpty(varietalsList)) {
					if (i == varietals.length - 1) {
						varietalsList += ' ' + i18nAndAdverb + ' '
					} else {
						varietalsList += ', '
					}
				}

				varietalsList += varietal.feature.name[language]
				varietalsList += varietal.value ? ' (' + varietal.value + '%)' : ''
			}
			varietalsList += '.'

			return varietalsList
		}

		this.getWineTypeColor = function (wineTypeSlug) {
			var color = null
			switch (wineTypeSlug) {
				case 'destilado_de_uva':
					color = '#ffffff'
					break
				case 'champagne':
				case 'espumante':
					color = '#d6d65d'
					break
				case 'tinto':
					color = '#be0009'
					break
				case 'rose':
					color = '#f95154'
					break
				case 'madeira':
				case 'jerez':
					color = '#ea8030'
					break
				case 'branco_fortificado':
				case 'branco_doce':
				case 'porto_branco':
					color = '#a38945'
					break
				case 'tinto_fortificado':
				case 'porto':
					color = '#990012'
					break
				case 'tinto_doce':
					color = '#740001'
					break
				case 'branco':
					color = '#f8f6c3'
					break
				default:
			}
			return color
		}
	},
])
